
        var result = require("!!../../../../node_modules/css-loader/index.js!./customer-search.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/customers/customer-search/customer-search.component.css
// module id = 2483
// module chunks = 1